export default __webpack_public_path__ + "static/Plots0075-95c004c49b5371be197660b457cc0a14.jpg";